import { StreamSource } from "../hooks/streams";
import { CompetitionId } from "@vote4dance/judging-types";
import { ClassItem } from "./classes";

export function GroupSource(competition_id: CompetitionId) {
    return new StreamSource<ClassItem[]>(`/groups/${competition_id}`);
}